var cell_default = {
  "cell": "pw7qq",
  "header": "_0A0zD",
  "selected": "TwUCs",
  "editing": "_40m47",
  "singleSelection": "_3Q7a5",
  "hideLastBlock": "_7mce-",
  "editorWrapper": "_0EqAf",
  "viewerWrapper": "WExAp",
  "hideFirstBlock": "lq6dl",
  "editor": "HRXdK",
  "edit": "Hqd8G",
  "view": "Q1yOE",
  "editingToolbarWrapper": "Uq0Fm",
  "selectAll": "RqNC3",
  "disableSelection": "W7O8T"
};
export {
  cell_default as default
};
//# sourceMappingURL=cell-scss.js.map
